import { ReactNode, useState } from "react";

import souscriptionApi, { SouscriptionApiType } from "@/api/souscriptionApi";
import Popin from "@/components/Popin";
import { useSnackbar } from "notistack";

const SupprimeSouscription = ({
  souscription,
  children,
}: {
  souscription: SouscriptionApiType;
  children: ReactNode;
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [afficheConfirmationSuppr, setAfficheConfirmationSuppr] =
    useState(false);

  const supprimerSouscription = async (souscription: SouscriptionApiType) => {
    try {
      await souscriptionApi.supprimerSouscriptionPNO(souscription.uuid);
      window.location.reload();
    } catch (error) {
      setAfficheConfirmationSuppr(false);
      enqueueSnackbar("Une erreur interne est survenue", {
        variant: "error",
      });
    }
  };

  return (
    <>
      <div onClick={() => setAfficheConfirmationSuppr(true)}>{children}</div>
      <Popin
        title={"Supprimer la souscription"}
        content={
          <div style={{ padding: 30 }}>
            Êtes vous sur, vous êtes sur le point de perdre les informations
            liés à cette souscription ?
          </div>
        }
        open={afficheConfirmationSuppr}
        maxWidth="sm"
        onClose={() => setAfficheConfirmationSuppr(false)}
        validateButtonLabel={"Supprimer"}
        onValidate={() => supprimerSouscription(souscription)}
      />
    </>
  );
};
export default SupprimeSouscription;
